import { BOT_CHALLENGE } from '@backmarket/nuxt-module-http-v2/constants'

import { useAlgoliaHost } from '../useAlgoliaHost/useAlgoliaHost'

type AlgoliaClientError = {
  transporterStackTrace: {
    response: {
      status: number
      content: string
    }
  }[]
}

function isAlgoliaClientError(error: unknown): error is AlgoliaClientError {
  return (
    typeof error === 'object' &&
    error !== null &&
    'transporterStackTrace' in error &&
    Array.isArray((error as AlgoliaClientError).transporterStackTrace)
  )
}

/**
 * The redirection to the test challenge page is already managed by nuxt-module-http-v2
 * This function should only be used when using another client library such as algoliasearch.
 */
export function useTestChallenge() {
  const host = useAlgoliaHost()

  function redirectToTestChallengePage() {
    if (import.meta.client) {
      // If the error is a bot challenge, we redirect the user to the challenge
      // page where they can solve the challenge and prove they are not a bot.
      // We add a 'next' query parameter with the current URL so the user can be
      // redirected back after completing the challenge.

      window.location.assign(
        `${host.protocol}://${host.url.value}${BOT_CHALLENGE.REDIRECT}?next=${encodeURIComponent(window.location.href)}`,
      )
    }
  }

  function isTestChallengeError(error: unknown) {
    if (!isAlgoliaClientError(error)) {
      return false
    }

    return (
      error.transporterStackTrace[0]?.response.content?.includes(
        BOT_CHALLENGE.TYPE,
      ) && error.transporterStackTrace[0]?.response.status === 403
    )
  }

  return {
    redirectToTestChallengePage,
    isTestChallengeError,
  }
}
